// extracted by mini-css-extract-plugin
module.exports = {"menuAction":"menu-action_menuAction__2SZox","Img":"menu-action_Img__up9JI","active":"menu-action_active__GNy2m"};